import React, { useState } from "react";
import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CFormLabel,
  CFormInput,
  CButton,
} from "@coreui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import AppToast from "../../components/seller/AppToast";
import { uploadCertificates } from "../../features/seller/sellerSlice";

const validationSchema = Yup.object().shape({
  type: Yup.string().required("Document type is required"),
  file: Yup.mixed().required("Document file is required"),
});

const CertificatesForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.seller.certificates);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState("info");
  const [toastMessage, setToastMessage] = useState("");

  const initialValues = {
    type: "",
    file: null,
  };

  const handleFormikSubmit = async (values, { setSubmitting, resetForm }) => {
    const submission = new FormData();
    // console.log("Values submitted:", values);
    submission.append("document_type", values.type);
    submission.append("file", values.file);
    try {
      const res = await dispatch(uploadCertificates(submission)).unwrap();
      setToastType("success");
      setToastMessage(res?.message || "Cetificate uploaded successfully.");
      setToastVisible(true);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } catch (err) {
      console.error("Upload failed:", err);
      setToastType("error");
      setToastMessage(err?.payload || err?.message || "Failed to upload cetificate.");
      setToastVisible(true);
    }
    setSubmitting(false);
  };

  return (
    <>
      <div className="container-fluid px-3">
        <CCard className="mt-4">
          <CCardBody>
            <CRow className="mb-4 align-items-center">
              <CCol>
                <h4 className="mb-0">Upload Certificates</h4>
              </CCol>
              <CCol className="text-end">
                <CButton color="secondary" onClick={() => navigate(-1)}>
                  Back
                </CButton>
              </CCol>
            </CRow>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleFormikSubmit}
            >
              {({
                values,
                setFieldValue,
                handleBlur,
                touched,
                errors,
                isSubmitting,
              }) => (
                <Form>
                  <div className="mb-3">
                    <CFormLabel htmlFor="type">Document Type</CFormLabel>
                    <CFormInput
                      id="type"
                      name="type"
                      type="text"
                      placeholder="Enter document type"
                      value={values.type}
                      onChange={(e) => setFieldValue("type", e.target.value)}
                      onBlur={handleBlur}
                    />
                    {touched.type && errors.type && (
                      <div className="text-danger">{errors.type}</div>
                    )}
                  </div>

                  <div className="mb-4">
                    <CFormLabel htmlFor="file">Upload Document</CFormLabel>
                    <CFormInput
                      type="file"
                      id="file"
                      name="file"
                      accept=".jpg,.jpeg,.png,.pdf"
                      onChange={(e) =>
                        setFieldValue("file", e.currentTarget.files[0])
                      }
                      onBlur={handleBlur}
                    />
                    {touched.file && errors.file && (
                      <div className="text-danger">{errors.file}</div>
                    )}
                  </div>

                  <div>
                    <CButton
                      type="submit"
                      color="primary"
                      disabled={isSubmitting || loading}
                    >
                      Upload
                    </CButton>
                  </div>
                </Form>
              )}
            </Formik>
          </CCardBody>
        </CCard>
      </div>
      <AppToast
        visible={toastVisible}
        setVisible={setToastVisible}
        type={toastType}
        message={toastMessage}
      />
    </>
  );
};

export default CertificatesForm;
